export default __webpack_public_path__ + "static/request-demo-bg-b5b6a1e0c97efdddd97a6c9e0dcc60bb.svg";